<script setup>
import teamupLogo from '@/core/assets/images/TeamUpLogo.svg'

const { t } = useI18n()
const { features: { hide_powered_by_teamup: hidePoweredByTeamUp } } = useFeatures()
</script>

<template>
  <div
    v-if="!hidePoweredByTeamUp"
    class="mb-10 mt-auto items-center flex-gap-x-2 lt-sm:flex sm:hidden"
  >
    <span class="ms-4 text-xs">{{ t('Powered by') }}</span>
    <img
      :src="teamupLogo"
      class="w-77px"
      alt="TeamUp"
    >
  </div>
</template>

<i18n>
{
  "en-us": {
    "Powered by": "Powered by"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Powered by": "Präsentiert von"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Powered by": "Propulsé par"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Powered by": "Desarrollado por"
}
</i18n>
